module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.new', {
            url: '/new?{pageNumber:int}&{sortBy}',
            reloadOnSearch: false,
            views: {
                'left-panel@shop': {
                    template: '<wow-new-products-nav></wow-new-products-nav>',
                },
                'center-panel@shop': {
                    controller: ['$state', function ($state) {
                        this.$state = $state;
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-new-products-tile-list
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy">
                        </wow-new-products-tile-list>
                    `,
                },
            },
            data: {
                pageMetadata: {
                    title: 'Shop New Products',
                    metaDescription: 'Shop New Products',
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/new.js